import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"h40 d-flex align-items-center bg-about section-padding mt-5 mt-md-0\"><div class=\"container\"><div class=\"row justify-content-center text-center\"><div class=\"col-sm-12 col-lg-10\"><h1 class=\"title text-shadow\">Quiénes somos</h1></div></div></div></section>", 1)
const _hoisted_2 = { class: "py-5 d-flex align-items-center" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "text-justify px-3" }
const _hoisted_7 = { class: "text-orange-400 text-bold py-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Somos una compañía 100% mexicana, que ayuda a las personas que buscan productos financieros, a llegar al que más les conviene, y al que sí los va a aprobar. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "text-secondary text-bold py-2 sub" }, " Somos una compañía preocupada por el bienestar de los mexicanos. ", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Sabemos que los fraudes están a la orden del día, ya que muchas empresas patito se dedican a robar la identidad de las personas, y a pedir depósitos para otorgar tarjetas o préstamos, y al final no son aprobados; por eso, en ")
const _hoisted_12 = { class: "text-orange-400" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" trabajamos únicamente con empresas reguladas ante las comisiones encargadas de la prevención de fraude. Puedes estar 100% seguro de que tus datos estarán seguros con nosotros, y de que sólo los usaremos para los fines que tú necesitas. ")
const _hoisted_14 = { class: "py-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" En ")
const _hoisted_16 = { class: "text-orange-400" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(", nos comprometemos a que la probabilidad de aprobación del producto que deseas, sea igual o mayor al 80%, ya que utilizamos un sistema de eliminación creado por nosotros, basándonos en tu perfil y necesidades, y nunca te ofreceremos un producto para el que no puedas aplicar. ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_19 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.name), 1),
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("p", null, [
                  _hoisted_11,
                  _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.name), 1),
                  _hoisted_13
                ]),
                _createElementVNode("p", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.name), 1),
                  _hoisted_17
                ])
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_router_link, { to: '/cuestionario' }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      label: "Quiero probar el servicio",
                      class: "p-button-raised p-button-rounded w-auto"
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}